import React,{useEffect} from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';


function PatientStats({patientData}) {
    useEffect(()=>{
       // console.log("Patient Data in Stats")
       /// console.log(patientData)
    },[])
    ChartJS.register(ArcElement, Tooltip, Legend);
    const data = {
        labels: ['Active Patients','Inactive Patients'],
        datasets: [
          {
            label: '# of Patients',
            data: [patientData.activePatient,patientData.inactivePatient],
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
            ],
            borderColor: [
              'rgba(255, 99, 132, 1)',
              'rgba(54, 162, 235, 1)',
            ],
            borderWidth: 1,
          },
        ],
      };
  return (
    <>
    
        <div>PatientStats</div>
        <Doughnut data={data}/>
    </>
  )
}

export default PatientStats